<template>
  <div :class="cardInfo.type == 'LianLian' ? 'card-info blue' : 'card-info red'">
    <div class="card-top">
      <div class="title-tag">
        <span :class="cardInfo.type == 'LianLian' ? 'blue' : 'red'">{{
          cardInfo.type == "LianLian" ? "连" : "锐"
          }}</span>
      </div>
      <div :class="cardInfo.type == 'LianLian' ? 'title blue' : 'title red'">
        {{ cardInfo.title }}
      </div>
      <div class="account-number" v-if="purseInfo && cardInfo.type == 'LianLian'">
        账号：{{ purseInfo.clearAccountNumber }}
      </div>
    </div>
    <div :class="cardInfo.type == 'LianLian' ? 'blue card-content' : 'red card-content card-accordant'
      ">
      <div class="amount" v-if="purseInfo">
        <div class="flex-row-between-center">
          <span>钱袋余额</span>
          <el-button type="text" :class="cardInfo.type == 'LianLian'
            ? 'text-btn'
            : 'text-btn text-btn-cash'
            " @click="goDetail(cardInfo.type)">查看明细<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
        <span class="amount-value">¥{{ purseInfo.balanceAmount }}</span>
      </div>
      <div class="item-cash" v-if="purseInfo">
        <span class="label">可提现金额</span>
        <span class="value">¥{{ purseInfo.withdrawAmount }}</span>
      </div>
      <div class="purse-img-item">
        <img :src="cardInfo.type == 'LianLian' ? LianPurse : RuiGuPurse" class="img-purse" alt="" />
      </div>
    </div>
    <div class="blue card-content card-extra" v-if="cardInfo.type == 'LianLian' && purseInfo">
      <div class="item-cash">
        <span class="label">未入账金额</span>
        <span class="value">¥{{ purseInfo.unreceivedAmount }}</span>
      </div>
    </div>
    <div class="card-bottom">
      <div v-if="cardInfo.type == 'LianLian'">
        <el-button class="tool-btn reset-pass" size="mini" @click="resetPass">重置密码</el-button>
        <el-button type="primary" size="mini" class="tool-btn lian-cash" @click="lianHandleCash">我要提现</el-button>
      </div>
      <div v-if="cardInfo.type == 'RuiGu'">
        <el-button type="primary" size="mini" class="tool-btn rui-gu-cash" @click="ruiGuHandleCash">我要提现</el-button>
      </div>
    </div>
    <!-- 提现 -->
    <el-dialog custom-class="cash-modal" append-to-body center :visible.sync="cashVisible" width="660px"
      @close="handleCancel">
      <template slot="title">
        <span class="title-top">{{ cardInfo.title }}</span>
        <span class="title-tip" v-if="cardInfo.type == 'LianLian'">*单笔可提现金额不超过100万</span>
      </template>
      <div class="cash-content">
        <div class="cash-item">
          <span class="label">银行户名：</span>
          <span class="value">
            <MaskViewVue type="maskName" :maskVal="cashInfo.accountName" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'passport',
              }),
            }" />
          </span>
        </div>
        <div class="cash-item">
          <span class="label">银行卡号：</span>
          <span class="value">
            <MaskViewVue type="maskBankCard" :maskVal="cashInfo.accountNumber" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'passport',
              }),
            }" />
          </span>
        </div>
        <div class="cash-item">
          <span class="label">提现金额：</span>
          <el-input type="number" v-model="cashForm.amount" placeholder="请输入提现金额" controls-position="right"
            :max="1000000" @change="handlePriceChange" @input="handleInput"
            :disabled="lianlianPriceDisabled && cardInfo.type == 'LianLian'"></el-input>
          <!--  oninput="(value)=>value.indexOf('.') > -1?value.slice(0, value.indexOf('.') + 3):value" -->
          <span v-if="lianlianPriceDisabled && cardInfo.type == 'LianLian'"
            style="color: #888;  margin-left: 20px;">全部提现</span>
          <span v-else class="all-cash-btn" @click="handleAllPrice">全部提现</span>
        </div>
        <div class="cash-item high-cash">
          *最高可提现金额：<span v-if="purseInfo">¥{{ purseInfo.withdrawAmount }}</span>
        </div>
        <div class="cash-item tip-poundage" v-if="cardInfo.type == 'LianLian' && purseInfo">
          <el-tooltip class="item" effect="dark" :content="cashInfo.postscript" placement="right">
            <div>
              <span>实际到账金额：</span><span v-if="realAmount">¥{{ realAmount }}</span>
              <i class="el-icon-warning-outline" style="color: #ff4d4f; margin-left: 10px; font-size: 20px;"></i>
            </div>
          </el-tooltip>
        </div>
        <div class="cash-item">
          <span class="label">手机号码：</span>
          <span class="value">
            <MaskViewVue type="maskPhone" :maskVal="cashInfo.reservePhone" :customParams="{
              expand: JSON.stringify({
                xAPIVersion: 'V1.0',
                xSystemID: 'passport',
              }),
            }" />
          </span>
          <span style="color: #ff4d4f; margin-left: 10px; font-size: 12px;"
            v-if="cardInfo.type == 'RuiGu' && !lianLianAccountStatus.open">【若需变更手机号，请联系锐锢业务员】</span>
        </div>
        <div class="cash-item">
          <span class="label">验证码：</span>
          <el-input v-model="cashForm.code" placeholder="请输入验证码"></el-input>
          <el-button v-if="!showTimer" type="primary" size="mini" class="code-btn" :loading="sendLoading"
            @click="sendCode">{{
              sendCodeText }}</el-button>
          <el-button v-if="showTimer" size="mini" class="code-btn-again">{{ timer }}s后重新发送</el-button>
        </div>
      </div>
      <template slot="footer">
        <el-button size="mini" @click="handleCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="handleSureCash" :loading="confirmLoading">确定</el-button>
      </template>
    </el-dialog>

    <expriate-modal ref="expriateModal" :corpId="this.corpId" :htmlTxt="this.htmlTxt" @goCash="goCash()" />
  </div>
</template>
<script>
import LianPurse from "@/assets/img/lian-purse.png";
import RuiGuPurse from "@/assets/img/rui-gu-purse.png";
import expriateModal from "./expriateModal.vue";
import { desensitization, formatNumber } from "@/utils/utils";
import debounce from "lodash/debounce";
import {
  cashMarkCode,
  sendCheckCode,
  sureCashCode,
  getRealAmount,
  getStatusFlagNew,
  cashRelateInfo,
  getStatusFlag,
  getPapAgreeApply
} from "@/models/purseSet";

import { MaskViewVue } from "ruigu-utils";
const threepublic1 = threepublic;

export default {
  props: {
    cardInfo: {
      type: "",
      title: ""
    },
    supplierId: "",
    corpId: "",
    purseInfo: {}, // 钱袋信息
    cashInfo: {}, // 钱袋提现信息
    lianLianAccountStatus: {} // 连连账户状态信息
  },
  data() {
    this.sendCode = debounce(this.sendCode, 800);
    this.handleSureCash = debounce(this.handleSureCash, 800);

    return {
      LianPurse, // 图标
      RuiGuPurse, // 图标
      cashVisible: false, // 提现弹窗
      showTimer: false, // 显示计时
      sendCodeText: "发送验证码",
      timer: 120, // 验证码计时时间
      flagTimer: 1, // 倒计时标记
      setTime: null, // 倒计时
      cashForm: {
        amount: undefined,
        code: ""
      },
      withdrawNo: "", // 提现单号
      realAmount: "", // 扣除手续费 实际到账金额
      confirmLoading: false,
      lianlianPriceDisabled: false,
      sendLoading: false,
      price: undefined,
      htmlTxt: "已过期"
    };
  },
  components: { expriateModal, MaskViewVue },

  created() {
    //console.log(this.lianLianAccountStatus, '214')
  },

  methods: {
    desensitization(value, start, end) {
      const data = desensitization(value, start, end);
      return data;
    },

    // 关闭提现弹窗
    handleCancel() {
      this.cashVisible = false;
      this.cashForm.amount = undefined;
      this.cashForm.code = "";
      this.realAmount = "";
      this.withdrawNo = "";
      this.lianlianPriceDisabled = false;
      this.showTimer = false;
      this.flagTimer = 1;
      this.sendCodeText = "发送验证码";
      this.timer = 120;
      clearInterval(this.setTime);
    },

    // 连连提现
    async lianHandleCash() {
      try {
        // 获取当前账户激活状态  判断当前公司清分账户的状态 激活状态 0 未激活 2激活中 1 激活完成
        const res = await getStatusFlagNew({ corpId: this.corpId });
        if (
          res.data.activation == 0 ||
          (res.data.activation == 1 && res.data.papStatus === -1)
        ) {
          // 未激活/未签约 跳转三方激活页面
          const url = `${threepublic1}/account-activation?corpId=${this.corpId
            }&token=${localStorage.getItem("token")}&c_type=4`;
          window.open(url);
        } else if (
          res.data.activation == 2 ||
          (res.data.activation == 1 && res.data.papStatus === 0)
        ) {
          this.$message.warning(
            "免密免验代发协议审核中，请耐心等待审核通过哦！"
          );
        } else if (res.data.activation == 1 && res.data.papStatus > 0) {
          this.papAgreeQuery();
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async papAgreeQuery() {
      // this.$refs.expriateModal.showModal(this.corpId, "EXPIRED");
      // return false;
      const params = {
        companyId: this.corpId,
        agreementType: "WITH_HOLD"
      };
      try {
        const res = await getPapAgreeApply(params);
        if (res.data) {
          const { signStatus } = res.data;
          switch (signStatus) {
            case "NORMAL": //正常，提现
              {
                this.goCash();
              }
              break;
            case "EXPIRED": //已过期，弹框
            case "EXPIRING_SOON": //即将过期，弹框
              {
                this.$refs.expriateModal.showModal(this.corpId, signStatus);
              }
              break;
            default:
              break;
          }
        }
      } catch (error) { }
    },

    // 激活完成可以出现提现弹窗(若无提现信息则调接口获取提现信息)
    goCash() {
      if (!this.cashInfo.accountName) {
        this.getCashInfo(2);
      } else {
        this.cashVisible = true;
      }
    },
    // 获取公司提现相关信息 1锐锢钱袋 2 清分钱袋
    getCashInfo(type) {
      const params = {
        corpId: this.corpId,
        bindAccountType: type,
        supplierId: this.supplierId
      };
      cashRelateInfo(params)
        .then(res => {
          if (res.data) {
            this.cashInfo = res.data;
            this.cashVisible = true;
          }
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },

    // 锐锢提现
    ruiGuHandleCash() {
      this.cashVisible = true;
    },

    // 重置密码
    async resetPass() {
      try {
        // 获取当前账户激活状态 判断当前公司清分账户的状态 激活状态 -1 未激活 0激活中 2 激活完成
        const res = await getStatusFlag({ corpId: this.corpId });
        if (res.data) {
          if (res.data.activationAndPapStatus == -1) {
            this.$message.warning("账户还未激活，暂时不可重置密码！");
            return;
          } else if (
            res.data.activationAndPapStatus == 0 ||
            res.data.activationAndPapStatus == 2
          ) {
            // 重置密码 跳转三方激活页面
            const url = `${threepublic1}/reset-password?corpId=${this.corpId
              }&token=${localStorage.getItem("token")}&c_type=4`;
            window.open(url);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },

    // 全部提现
    handleAllPrice() {
      if (Number(this.purseInfo.withdrawAmount) !== 0) {
        this.cashForm.amount = this.purseInfo.withdrawAmount;
        if (this.cardInfo.type == "LianLian") {
          this.computeRealAmount(this.cashForm.amount);
        }
      } else {
        this.$message.warning("当前可提现余额为0，暂不可提现！");
      }
    },

    // 提现金额change
    handlePriceChange(value) {
      if (value && Number(value) > 0) {
        this.cashForm.amount = String(value).replace(/[^\d^\.]/g, "");
        // 计算实际到账金额
        if (this.cardInfo.type == "LianLian") this.computeRealAmount(value);
      } else {
        this.$message.warning("请输入大于0的数字！");
        this.realAmount = "";
      }
    },
    handleInput(val) {
      const newval = formatNumber(val);
      this.cashForm.amount = newval; // 在进行赋值
    },
    // 获取实际到账金额
    computeRealAmount() {
      const params = {
        companyId: this.corpId,
        supplierId: this.supplierId,
        withdrawAmount: this.cashForm.amount
      };
      getRealAmount(params)
        .then(res => {
          if (res.data) {
            this.realAmount = res.data.arrivalAmount;
          }
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },

    // 点击发送验证码
    sendCode() {
      const type = this.cardInfo.type == "LianLian" ? 2 : 1;

      if (!this.cashInfo.accountNumber) {
        this.$message({
          message: "请先绑定银行卡",
          type: "warning"
        });
        return;
      }
      if (!this.cashForm.amount) {
        this.$message({
          message: "请输入提现金额！",
          type: "warning"
        });
        return;
      }
      if (Number(this.cashForm.amount) < 0) {
        this.$message({
          message: "请输入大于0的提现金额！",
          type: "warning"
        });
        return;
      }
      if (
        Number(this.cashForm.amount) > Number(this.purseInfo.withdrawAmount)
      ) {
        this.$message({
          message: "提现金额不能大于最高可提现金额！",
          type: "warning"
        });
        return;
      }

      if (!this.cashInfo.reservePhone) {
        this.$message({
          message: "手机号码不能为空！",
          type: "warning"
        });
        return;
      }

      this.sendLoading = true;

      if (this.flagTimer == 1) {
        // 首次申请提现 并短信验证码
        this.applyWithdraw(type);
      } else if (this.flagTimer == 2) {
        // 重新发送验证码 入参 传withdrawNo 提现单号
        this.pendingSendConde(type);
      }
    },

    // 申请提现 同时发送验证码
    async applyWithdraw(type) {
      const params = {
        corpId: this.corpId,
        purchaseChannel: 4,
        purseType: type,
        supplierId: this.supplierId,
        withdrawAmount: this.cashForm.amount
      };

      const res = await cashMarkCode(params);
      if (res.data && res.data.result) {
        this.withdrawNo = res.data.withdrawNo;
        // 倒计时
        this.sendCodeing();
        this.sendLoading = false;
        this.$message({
          message: "发送验证码成功",
          type: "success"
        });
        if (this.cardInfo.type == "LianLian") this.lianlianPriceDisabled = true;
      } else {
        this.sendLoading = false;
      }
    },

    // 重新发送验证码
    pendingSendConde(type) {
      sendCheckCode({
        supplierId: this.supplierId,
        corpId: this.corpId,
        withdrawNo: type == 2 ? this.withdrawNo : undefined,
        purseType: type
      })
        .then(res => {
          if (res.code === 200) {
            // 倒计时
            this.sendCodeing();
            this.sendLoading = false;
            this.$message({
              message: "发送验证码成功",
              type: "success"
            });
            if (this.cardInfo.type == "LianLian")
              this.lianlianPriceDisabled = true;
          } else {
            this.sendLoading = false;
          }
        })
        .catch(err => {
          this.$message.error(err.msg);
          this.sendLoading = false;
        });
    },

    // 验证码发送中
    sendCodeing() {
      this.showTimer = true;
      this.flagTimer = 1;
      this.setTime = setInterval(() => {
        this.timer = this.timer - 1;
        if (this.timer <= 0) {
          clearInterval(this.setTime);
          this.timer = 120;
          this.showTimer = false;
          this.sendCodeText = "重新发送";
          this.sendLoading = false;
          this.flagTimer = 2;
        }
      }, 1000);
    },

    // 确定提现
    handleSureCash() {
      const type = this.cardInfo.type == "LianLian" ? 2 : 1;
      if (!this.withdrawNo && this.cardInfo.type == "LianLian") {
        this.$message({
          message: "请获取短信验证码！",
          type: "warning"
        });
        return;
      }

      if (!this.cashForm.code) {
        this.$message({
          message: "请输入验证码！",
          type: "warning"
        });
        return;
      }

      const params = {
        corpId: this.corpId,
        purchaseChannel: 4,
        purseType: type,
        supplierId: this.supplierId,
        withdrawAmount: this.cashForm.amount,
        verifyCode: this.cashForm.code,
        withdrawNo: this.withdrawNo
      };
      this.confirmLoading = true;
      sureCashCode(params)
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "提现成功！",
              type: "success"
            });
            this.cashForm.amount = undefined;
            this.cashForm.code = "";
            this.withdrawNo = "";
            this.confirmLoading = false;
            this.cashVisible = false;
            // 刷新钱袋
            this.$parent.initPurseList();
            this.$parent.getCashInfo(type);
          } else {
            this.confirmLoading = false;
          }
        })
        .catch(error => {
          this.confirmLoading = false;
          this.$message.error(error.message);
          if (error.code == 98947) {
            this.handleCancel()
          }
        });
    },
    // 查看明细
    goDetail(type) {
      // console.log("goDetail:", type, this.supplierId, this.corpId);
      const pageName = type == "LianLian" ? "wallet-lian" : "wallet-cash";
      const url = `${pageName}?corpId=${this.corpId}&channel=4&supplierId=${this.supplierId}`;
      this.$router.push({
        name: "purseDetail",
        params: {
          path: url
        }
      });
    }
  }
};
</script>
<style lang="scss">
.card-info {
  width: 380px;
  padding: 20px;
  border-radius: 8px;
  margin-right: 20px;
  position: relative;

  &.blue {
    background: linear-gradient(291deg, #f0f7ff 0%, #dceaff 100%);
  }

  &.red {
    background: linear-gradient(288deg, #fff5f1 0%, #ffe4d6 100%);
  }

  .card-top {
    display: flex;
    justify-content: start;
    align-items: center;

    .title-tag {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #ffffff;
      text-align: center;
      line-height: 36px;

      .blue {
        color: #2186fc;
        font-size: 16px;
      }

      .red {
        color: #ff6124;
        font-size: 16px;
      }
    }

    .title {
      font-size: 18px;
      margin: 0 10px;

      &.blue {
        color: #2186fc;
      }

      &.red {
        color: #ff6124;
      }
    }

    .account-number {
      color: #000000;
      font-size: 14px;
    }
  }

  .card-content {
    padding: 10px;
    margin-top: 15px;
    position: relative;
    margin-bottom: 60px;
    height: 142px;

    &.blue {
      background: #f4faff;
      border-radius: 8px;
    }

    &.red {
      background: #fff8f4;
      border-radius: 8px;
    }

    &.card-extra {
      height: 30px;
      line-height: 30px;
      margin-top: -50px;
    }

    &.card-accordant {
      height: 202px;
    }

    .item-cash {
      margin-bottom: 10px;
      display: flex;

      .label {
        color: #8f9193;
        width: 100px;
        text-align: left;
      }

      .value {
        color: #202327;
      }
    }

    .amount {
      padding-bottom: 10px;
      border-bottom: 1px dashed rgba(134, 134, 134, 0.99);
      margin-bottom: 10px;

      .amount-value {
        font-weight: 800;
        color: #333;
        font-size: 22px;
        margin-left: 10px;
      }
    }

    .purse-img-item {
      position: absolute;
      bottom: 5px;
      right: 10px;

      .img-purse {
        width: 50px;
        height: 50px;
      }
    }
  }

  .card-bottom {
    position: absolute;
    right: 0;
    bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    .tool-btn {
      width: 120px;
      height: 34px;
      border-radius: 4px;
    }

    .reset-pass {
      border: 1px solid #3489ed;
      color: #3489ed;
      background: none;
    }

    .lian-cash {
      background: #2186fc;
      border: none;
    }

    .rui-gu-cash {
      background: #ff6124;
    }
  }

  .text-btn {
    background: none !important;
    border: none !important;
  }

  .text-btn-cash {
    color: #ff6224;
  }
}

.cash-modal {
  border-radius: 8px;

  .el-dialog__header {
    background-color: #fff !important;
    text-align: left;
    padding: 20px 20px 0 !important;
    border-radius: 10px;
    position: relative;

    .title-top {
      color: #303133 !important;
      font-weight: bold;
      font-size: 18px;
    }

    .title-tip {
      color: #faad14;
      margin-left: 20px;
    }

    .el-icon-close {
      color: #333 !important;
      margin-top: 10px;
    }
  }

  .cash-content {
    .cash-item {
      margin-bottom: 10px;
      display: flex;
      justify-content: start;
      align-items: center;

      .label {
        color: #262626;
        width: 80px;
        text-align: right;
      }

      .value {
        color: #595959;
      }

      .all-cash-btn {
        color: #ff4d4f;
        margin-left: 20px;
        cursor: pointer;
      }

      .code-btn {
        margin-left: 20px;
      }

      .code-btn-again {
        margin-left: 20px;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: rgba(0, 0, 0, 0.65);
      }
    }

    .high-cash {
      color: #ff4d4f;
    }

    .tip-poundage {
      color: #000000;
    }

    .tip-poundage,
    .high-cash {
      margin-left: 90px;
    }

    .el-input-number {
      width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/withdrawal/components/cashCard.vue